import React, { Component } from "react";
import PropTypes from "prop-types";
import { withUser } from "@unifiedpatents/sso";
import { Card, Table } from "antd";

import TimeLine from "../common/timeline";
import LoadingWrapper from "../common/loading-wrapper";
import { toDateString, toReexamDocLink } from "../../helpers/converters";
import { sorterStringGen } from "../../helpers/table";

const styles = {
  gutter: {
    marginTop: 16
  }
};

class TransactionHistoryWithTimeline extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired
  };

  state = {
    isSelected: () => undefined,
    selectedFilingKey: null
  };

  render() {
    const { data, loading } = this.props;
    const { isSelected, selectedFilingKey } = this.state;
    const applicationNumber = data.application_number;
    const transactionHistory = data.transactions ? data.transactions : [];
    const transformTimelineData = data =>
      data.map(d => ({
        date: d.date,
        label: d.text,
        key: d.code
      }));
    const tableHeaders = [
      {
        dataIndex: "date",
        title: "Date",
        width: 150,
        render: toDateString,
        defaultSortOrder: "descend",
        sorter: sorterStringGen("date")
      },
      {
        dataIndex: "code",
        title: "Code",
        width: 150
      },
      {
        dataIndex: "text",
        title: "Transaction Description",
        render: (val, record) => (record.doc_id ? toReexamDocLink(val, applicationNumber, record.doc_id) : val)
      }
    ];
    const tableScroll = {
      x: 1200,
      y: 300
    };
    const rowClassName = record => (selectedFilingKey === record.key ? "up-antd-table-row-selected" : null);
    return (
      transactionHistory.length > 0 && (
        <>
          <Card title="Timeline">
            <LoadingWrapper loading={loading}>
              <TimeLine
                data={transformTimelineData(transactionHistory)}
                importantLabels={[transactionHistory[0].text]}
                onPointSelection={this._onFilingSelection}
                isSelected={isSelected}
                cycleSize={5}
                numMonths={30}
              />
            </LoadingWrapper>
          </Card>
          <Card title={<span>{"Transaction History"}</span>} style={styles.gutter} className="Docket">
            <Table columns={tableHeaders} dataSource={transactionHistory} rowClassName={rowClassName} onRow={this._onRow} loading={loading} pagination={false} scroll={tableScroll} size="small" />
          </Card>
        </>
      )
    );
  }

  _handleScroll = () => {
    let elements = document.getElementsByClassName("up-antd-table-row-selected");
    if (elements[0]) {
      const topPosition = elements[0].offsetTop;
      document.querySelector(".ant-table-body").scrollTop = topPosition;
      document.getElementById("docketTable").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  };

  _deselectFiling = () => {
    this.setState({
      selectedFilingKey: null,
      isSelected: () => undefined
    });
  };

  _onFilingSelection = selectedFilingKey => {
    if (selectedFilingKey === this.state.selectedFilingKey) {
      this._deselectFiling();
    } else {
      this.setState({ isSelected: d => d.key === selectedFilingKey, selectedFilingKey: selectedFilingKey }, this._handleScroll);
    }
  };

  _onRow = a => {
    if (a && a.key >= 0) {
      return {
        onClick: () => {
          const selectedFilingKey = a.key; // only one row can be selected in this table
          if (selectedFilingKey === this.state.selectedFilingKey) {
            this._deselectFiling();
          } else {
            this.setState({
              isSelected: d => d.key === selectedFilingKey,
              selectedFilingKey: selectedFilingKey
            });
          }
        }
      };
    }
  };
}

export default withUser(TransactionHistoryWithTimeline);
